import "../Styles/index.scss";
import { Fancybox } from "@fancyapps/ui";

const ExpandedAttributeName = "aria-expanded";
const HeightAnimationDuration = 400;
const HeightAnimationEasing = "ease-in-out";

Fancybox.bind(".gallery-item__link");

for (const element of document.querySelectorAll<HTMLElement>(".opus-overview")) {
	const targetId = element.getAttribute("aria-controls");
	if (targetId == null) {
		continue;
	}

	const target = document.getElementById(targetId);
	if (target == null) {
		continue;
	}

	target.dataset.height = target.offsetHeight.toString();
	target.style.height = "0px";

	const isExpanded = () => element.getAttribute(ExpandedAttributeName) === "true";
	const rotateKnob = initializeKnob(element);
	const angle = parseFloat(element.getAttribute("data-angle") || "0");

	element.addEventListener("mouseenter", () => {
		if (!isExpanded()) {
			rotateKnob(angle + 15);
		}
	});
	element.addEventListener("mouseleave", () => {
		if (!isExpanded()) {
			rotateKnob(angle);
		}
	});

	element.addEventListener("click", () => {
		if (isExpanded()) {
			animateHeight(target, 0);
			element.setAttribute(ExpandedAttributeName, "false");
		} else {
			for (const expanded of document.querySelectorAll(".opus-overview[aria-expanded=\"true\"]")) {
				expanded.dispatchEvent(new Event("click"));
			}
			animateHeight(target, parseFloat(target.dataset.height || "0"), () => target.style.height = "auto");
			element.setAttribute(ExpandedAttributeName, "true");
		}
	});

	target.querySelector(".opus-detail__close")?.addEventListener("click", () => {
		if (isExpanded()) {
			element.dispatchEvent(new Event("click"));
		}
	});
}

function animateHeight(target: HTMLElement, to: number, onFinish?: () => void) {
	const from = target.getBoundingClientRect().height;
	for (const animation of target.getAnimations()) {
		animation.cancel();
	}

	target.style.height = `${to}px`;
	const animation = target.animate(
		[{ height: `${from}px` }, { height: `${to}px` }],
		{ duration: HeightAnimationDuration, easing: HeightAnimationEasing }
	);
	if (onFinish != null) {
		animation.onfinish = onFinish;
	}
}

function initializeKnob(element: HTMLElement) {
	const path = element.querySelector<SVGPathElement>(".knob .icon-knob-mask path.light");
	const indicator = element.querySelector<HTMLElement>(".knob .indicator");
	if (path == null || indicator == null) {
		return (_angle: number) => { };
	}

	const pathLength = path.getTotalLength();
	path.style.strokeDasharray = `${pathLength} ${pathLength}`;
	path.style.strokeDashoffset = `-${pathLength}`;
	path.getBoundingClientRect(); // flush styles so the first rotation transitions from the fully hidden stroke

	// The stroke offset and the indicator rotation are animated by the CSS transitions on ".knob".
	const rotate = (angle: number) => {
		path.style.strokeDashoffset = `-${Math.floor(pathLength * (1 - (angle / 360)) / 16) * 16}`;
		indicator.style.transform = `rotate(${angle}deg)`;
	};

	rotate(parseFloat(element.getAttribute("data-angle") || "0"));
	return rotate;
}
